<template>
  <div>
    <el-radio-group v-if="showPick" v-model="type_device" style="margin-bottom: 20px;">
      <el-radio-button :label="true">Gateway</el-radio-button>

      <!--:disabled="!(project && project.gateways)? true : false"-->
      <el-tooltip 
        class="item" :disabled="true" effect="dark" content="No gateway found in the project !"
        placement="bottom">
        <!--:disabled="project && project.gateways? true : false"-->
        <el-radio-button :label="false">End Device</el-radio-button>
      </el-tooltip>
    </el-radio-group>

    <el-container v-loading="loadingSensorTypes">
      <el-header>

        <el-steps :type_device="type_device" :active="active" finish-status="success">

          <el-step :title="type_device?'Gateway':'End Device'">

          </el-step>

          <el-step title="Sensors">

          </el-step>

          <el-step :title="type_device?'Confirm':'Gateway'">

          </el-step>


          <!--<el-step :title="type_device?'Configuration':'Confirm'">-->

          <!--</el-step>-->


        </el-steps>

      </el-header>

      <el-main>

        <div v-show="active===0">
          <gatwayinitform ref="addDevice" :project-id="project.id" :type_device="type_device">

          </gatwayinitform>
        </div>

        <div v-show="active===1">
          <sensor-types :sensor-type='sensorTypes'>

          </sensor-types>
        </div>

        <div v-if="active===2">

          <confirm v-if="type_device">

          </confirm>
          <div v-else>
            <template v-for="gateway in project.gateways">
              <div :key="gateway.id">
                <input v-model="device.idParent" name="gateway" :value="gateway.id" type="radio"/>
                <label> {{gateway.name}}</label>
              </div>
            </template>
          </div>
        </div>


        <div v-show="active===3&&type_device">
          <gateway_configuration v-if="type_device" :conf="configuration">

          </gateway_configuration>
        </div>


      </el-main>

      <el-footer>

        <el-button v-if="this.active>0 && this.active<3" style="margin-top: 12px;" @click="previous()">Previous step
        </el-button>
        <el-button style="margin-top: 12px;" @click="next" v-loading="loading"> {{active===2?'Done':'Next step'}}
        </el-button>

      </el-footer>
    </el-container>
  </div>
</template>

<script>
import Gatwayinitform from "./subComponents/gatewayinitform";
import { post } from "../../../API/cloudFunctions";
import SensorTypes from "./subComponents/sensorTypes";
import Gateway_configuration from "./subComponents/gateway_configuration";

import confirm from "../../project/components/confirm";

import errorMixin from "../../mixins/errorMixin";
import Gateway_choice from "./subComponents/gateway_choice";

const uuidv4 = require("uuid/v4");

export default {
  mixins: [errorMixin],
  components: {
    Gateway_choice,
    Gateway_configuration,
    SensorTypes,
    Gatwayinitform,
    confirm
  },
  name: "NewGateWay",
  Mixins: [errorMixin],
  data() {
    return {
      type_device: true,
      loadingSensorTypes: false,
      sensorTypes: [],
      device: {
        name: "",
        id: "",
        idProject: "",
        token: "",
        description: "",
        send_update_cron: "0 0 * * *",
        connection_type: "ethernet"
      },
      showPick: true,
      active: 0,
      configuration: "",
      loading: false,
      sensors: []
    };
  },
  props: {
    project: {
      type: Object,
      required: true
    }
  },
  methods: {
    initialize() {
      this.active = 0;
      this.sensors = [];
      this.device = {
        name: "",
        id: "",
        idProject: "",
        token: "",
        description: "",
        send_update_cron: "0 0 * * *"
      };
      this.showPick = true;
      this.loading = false;
    },
    next() {
      switch (this.active) {
        case 0:
          this.showPick = false;
          this.$refs.addDevice.generateId();
          // this.$refs.addDevice.setComms();
          this.device = this.$refs.addDevice.device;

          if (this.sensorTypes.length === 0) {
            this.loadingSensorTypes = true;

            post("getSensorsType", { data: { uid: "default" } })
              .then(success => {
                this.sensorTypes = success;
                /* eslint-disable no-param-reassign */
                this.sensorTypes.forEach(sensor => {
                  sensor.idParent = this.device.id;
                });
                this.loadingSensorTypes = false;
                this.active = 1;
              })
              .catch(error => {
                this.showError();
                this.loadingSensorTypes = true;
              });
          } else {
            this.active = 1;
          }

          break;
        case 1:
          this.active = 2;
          break;
        case 2:
          this.sensors = this.sensorTypes.filter(item => {
            if (item.check) {
              delete item.check;
              delete item.id;
              return true;
            }
            return false;
          });
          //getting the sensors that have been checked  and removing the attribute check so it would not be saved in the data store.

          //appending the project id to the device before it's being sent.
          this.device.idProject = this.type_device ? this.project.id : "-1";

          if (this.type_device) {
            this.loading = true;
            this.$store
              .dispatch("addGateway", {
                data: {
                  gateway: this.device,
                  sensors: this.sensors
                }
              })
              .then(success => {
                this.configuration = success;
                this.loading = false;
                // this.active = 3;
                location.reload(); //FIXME: NEED TO HANDLE THE REFRESH
                this.done();
              })
              .catch(error => {
                this.showError(error);
                this.loading = false;
              });
          } else {
            this.loading = true;
            delete this.device.token;
            delete this.device.send_update_cron;

            this.$store
              .dispatch("addDevice", {
                data: { data: { device: this.device, sensors: this.sensors } },
                idProject: this.project.id
              })
              .then(success => {
                this.configuration = success;
                this.done();
                this.loading = false;
                location.reload(); //FIXME: NEED TO HANDLE THE REFRESH
              })
              .catch(error => {
                this.showError(error);
                this.loading = false;
              });

            //
          }

          break;

        // case 3:
        //
        //
        //   if (!this.type_device) {
        //     this.loading = true;
        //     delete this.device.token;
        //     delete this.device.send_update_cron;
        //
        //     this.$store.dispatch('addDevice', {
        //       data: {data: {device: this.device, sensors: this.sensors}},
        //       idProject: this.project.id
        //     }).then(success => {
        //       this.configuration = success;
        //       this.done();
        //       this.loading = false;
        //
        //
        //     }).catch(error => {
        //       this.showError(error);
        //       this.loading = false;
        //     });
        //
        //   } else {
        //
        //     this.done();
        //   }
        //
        //
        //   break;
      }
    },
    previous() {
      this.active > 0 ? this.active-- : this.active;
      if (this.active === 0) {
        this.showPick = true;
      }
    },
    created() {},
    done() {
      Object.assign(this.$data, this.$options.data.apply(this));
      // location.reload();
      this.$emit("closeDialog");
    }
  }
};
</script>

<style scoped>
.el-container {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/settings/newGateWay/newGateWay.vue